import styled, { CSSObject } from '@emotion/styled'
import { UseFormReturn } from 'react-hook-form'
import { FormFields } from './types'

type SwitchButtonProps = {
  name: keyof FormFields
  register: UseFormReturn<FormFields>['register']
  labelText?: string
  color?: string
}

const Switch = ({ register, name, labelText, color }: SwitchButtonProps) => {
  return (
    <>
      <SwitchInput {...register(name)} id={name} type={'checkbox'} />
      <SwitchOutline
        htmlFor={name}
        data-testid={`${name}_switch`}
        color={color}
      >
        <SwitchButton />
      </SwitchOutline>
      {labelText && <SwitchLabel htmlFor={name}> {labelText} </SwitchLabel>}
    </>
  )
}

const SwitchOutline = styled.label(({ color }) => ({
  flexShrink: 0,
  display: 'inline-block',
  verticalAlign: 'top',
  width: '32px',
  height: '16px',
  backgroundColor: color || '#ddd',
  borderRadius: '48px',
  position: 'relative',
  cursor: 'pointer',
  ...(!color && {
    transition: 'background-color 300ms linear',
    '&:hover': {
      background: '#ccc'
    }
  })
}))

const SwitchButton = styled.div(
  (): CSSObject => ({
    content: '""',
    display: 'block',
    position: 'absolute',
    top: '2px',
    left: '2px',
    height: '12px',
    width: '12px',
    background: 'white',
    borderRadius: '50%',
    transition: 'transform 300ms ease-in'
  })
)

const SwitchInput = styled.input(({ theme }) => ({
  display: 'none',
  '&:checked + label': {
    background: theme.colors.black,
    '> div': {
      transform: 'translate3d(16px, 0, 0)'
    }
  }
}))

const CheckoutActions = styled.div(({ theme }) => ({
  zIndex: 2,
  position: 'fixed',
  bottom: '0',
  left: '0',
  right: '0',
  display: 'flex',
  '> button:not(:last-of-type)': { margin: '0 0 10px' },
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0 -1px 8px 8px rgba(0, 0, 0, 0.05)',
  flexDirection: 'column',
  [theme.mediaQueries.viewport6]: {
    boxShadow: 'none',
    position: 'relative',
    padding: '0'
  }
}))

const SwitchLabel = styled.label(({ theme }) => ({
  fontWeight: theme.fontWeights.bold,
  fontSize: theme.fontSizes[0],
  marginLeft: '8px'
}))

export { Switch, CheckoutActions }
